import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const useGender = function () {
  let useTargetEnums = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const {
    t
  } = useTranslation();
  const [gender, setGender] = useState();
  const defaultValues = [{
    label: t('GENERAL.male'),
    value: useTargetEnums ? 'male' : 'M'
  }, {
    label: t('GENERAL.female'),
    value: useTargetEnums ? 'female' : 'F'
  }];
  if (!gender && !useTargetEnums) {
    setGender(defaultValues);
  }
  if (!gender && useTargetEnums) {
    setGender([...defaultValues, {
      label: t('GENERAL.both'),
      value: 'all'
    }]);
  }
  return gender;
};
export { useGender };